import { mountHTTPInstance } from '@ghq-abi/auth-client-lib/client';

export const lcmApi = mountHTTPInstance({
  baseURL: process.env.NEXT_PUBLIC_LCM_API_URL,
});

export const peoplePlatformApi = mountHTTPInstance({
  baseURL: process.env.NEXT_PUBLIC_PEOPLE_PLATFORM_API_URL,
});
